import {
  RETRIEVAL_GUARDIAN_BOND,
} from "../guardianFormConfig";
import {
  LabeledCreatableSelect,
  splitEmploymentOccupation,
  joinEmploymentOccupation,
} from "./ProbateBondFormShared";
import GoogleAutoComplete from "./ProbateGoogleAutoComplete";
import RetrievalGuardianFormBase from "./RetrievalGuardianFormBase";

export default function ProbateGuardianForm(props) {
  return (
    <RetrievalGuardianFormBase
      bondKind={RETRIEVAL_GUARDIAN_BOND.probate}
      GoogleAutoComplete={GoogleAutoComplete}
      LabeledCreatableSelect={LabeledCreatableSelect}
      splitEmploymentOccupation={splitEmploymentOccupation}
      joinEmploymentOccupation={joinEmploymentOccupation}
      {...props}
    />
  );
}
